import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import fr from "./locales/fr.json";
import ar from "./locales/ar.json";
import en from "./locales/en.json";

export const SUPPORTED_LANGS = ["fr", "ar", "en"] as const;
export type SupportedLang = (typeof SUPPORTED_LANGS)[number];
export const DEFAULT_LANG: SupportedLang = "fr";

export function getLangFromPath(pathname: string): SupportedLang {
  const seg = pathname.split("/")[1];
  if (SUPPORTED_LANGS.includes(seg as SupportedLang)) return seg as SupportedLang;
  return DEFAULT_LANG;
}

export function stripLangFromPath(pathname: string): string {
  const seg = pathname.split("/")[1];
  if (SUPPORTED_LANGS.includes(seg as SupportedLang)) {
    return pathname.slice(seg.length + 1) || "/";
  }
  return pathname;
}

export function withLang(lang: SupportedLang, path: string): string {
  const clean = path.startsWith("/") ? path : `/${path}`;
  return `/${lang}${clean === "/" ? "" : clean}`;
}

i18n.use(initReactI18next).init({
  resources: {
    fr: { translation: fr, ...fr },
    ar: { translation: ar, ...ar },
    en: { translation: en, ...en },
  },
  lng: DEFAULT_LANG,
  fallbackLng: DEFAULT_LANG,
  interpolation: { escapeValue: false },
});

export default i18n;
